import { Component } from 'react';
import { connect } from 'react-redux';

import DirectionArraw from 'components/atoms/DirectionArraw';
import Icon from 'components/atoms/Icon';
import LoaderSpinner from 'components/atoms/LoaderSpinner';
import { Tooltip } from 'react-tooltip';
import { bindActionCreators } from 'redux';
import { ShowMessageAction, showMessageAction } from 'store/actions/errorsActions';
import { setOutlineIntervalAction } from 'store/actions/mapActions';
import { twMerge } from 'tailwind-merge';
import {
    DataDisplayType,
    EnviroDisplayType,
    OpenModal,
    PortType,
    PositionType,
    RootState,
    SwitchType,
    ToolTipType,
    TrackType,
    UserType,
} from 'types';
import { MainControlsInterface, MapControlsInterface, MenuControlsInterface } from 'types/functions';
import { MetOceanData } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent, clone } from 'utils/formHandlers';
import { hasPermission } from 'utils/permission';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';

interface VesselToolTipProps {
    //unused props
    outlineInterval: number;
    toolTip: ToolTipType;

    //unused props
    mainControls: MainControlsInterface;

    menuControls: MenuControlsInterface;
    mapControls: MapControlsInterface;
    currentTime: DateTimeFormat | null;
    mode: string;
    port: PortType;

    //unused props
    dateTimeFormat: DateTimeFormat;

    //unused props
    openModelFunction: OpenModal;
    showMessageAction: ShowMessageAction;
    //unused props
    setOutlineIntervalAction: (outlineInterval: number) => void;

    switchs: SwitchType;
    user: UserType;
}

interface VesselToolTipState {
    toolTip: ToolTipType | null;
    track: TrackType | null;
    dataDisplay: DataDisplayType;
    position: PositionType | null;
    loading: boolean;
    switchs: SwitchType;
    analysisVariables: any;
    metOceanData: MetOceanData[];
    enviroDisplay: EnviroDisplayType;
    activeTab: string;
}

class VesselToolTip extends Component<VesselToolTipProps, VesselToolTipState> {
    constructor(props: VesselToolTipProps) {
        super(props);
        this.state = {
            enviroDisplay: props.port.meta_data.enviroDisplay,
            dataDisplay: props.port.meta_data.dataDisplay,
            toolTip: clone(props.toolTip),
            position: null,
            track: null,
            loading: true,
            activeTab: 'wind',
            switchs: clone(props.switchs),
            analysisVariables: props.port.meta_data.analysisVariables,
            metOceanData: [],
        };
    }

    static getDerivedStateFromProps(props: VesselToolTipProps, state: VesselToolTipState) {
        if (checkDifferent(props.switchs, state.switchs)) {
            return {
                switchs: clone(props.switchs),
            };
        }

        if (checkDifferent(props.toolTip, state.toolTip)) {
            return {
                toolTip: clone(props.toolTip),
                track: null,
                position: null,
                loading: true,
            };
        }
        return null;
    }

    componentDidMount(): void {
        this.setState(
            {
                toolTip: this.props.toolTip,
            },
            this.loadTrackData
        );
    }

    componentDidUpdate(prevProps: VesselToolTipProps, prevState: VesselToolTipState) {
        if (checkDifferent(prevState.toolTip, this.state.toolTip)) {
            this.loadTrackData();
        }
    }

    activeTab = (activeTab: string) => {
        this.setState({
            activeTab,
        });
    };

    loadTrackData = async () => {
        const metOceanData = await this.props.menuControls?.playback?.getMetOceanByTime(
            this.state.toolTip?.dataIndex.time
        );

        this.setState({
            loading: false,
            //@ts-ignore
            metOceanData: metOceanData,
            //@ts-ignore
            track:
                this.props.mode === 'playback'
                    ? //@ts-ignore
                      this.props.menuControls.playback.getTrack(this.state.toolTip?.data.parent)
                    : //@ts-ignore
                      this.props.menuControls.time.getTrack(this.state.toolTip?.data.parent),
            //@ts-ignore
            position:
                this.props.mode === 'playback'
                    ? //@ts-ignore
                      this.props.menuControls.playback.getBestPosition(
                          this.state.toolTip?.data.parent,
                          this.state.toolTip?.dataIndex.index,
                          {
                              //@ts-ignore
                              east_utm: this.state.toolTip?.east_utm,
                              //@ts-ignore
                              north_utm: this.state.toolTip?.north_utm,
                          },
                          this.state.toolTip?.dataIndex.dataType
                      )
                    : //@ts-ignore
                      this.props.menuControls.time.getBestPosition(
                          this.state.toolTip?.data.parent,
                          null, //this.state.toolTip?.data.dataIndex.index,
                          {
                              //@ts-ignore
                              east_utm: this.state.toolTip?.east_utm,
                              //@ts-ignore
                              north_utm: this.state.toolTip?.north_utm,
                          }
                      ),
        });
    };

    getDisplay = (type: string, key: string) => {
        const dataDisplay = this.state?.dataDisplay;

        if (dataDisplay?.[type]?.[key]) {
            return dataDisplay[type][key];
        }

        return {};
    };

    displayValue = (value, group = 'transit') => {
        if (!this.state.position) {
            return '-';
        }

        if (this.state.position[value] === 'N/A' || !this.state.position[value]) {
            return 'N/A';
        }

        return `${parseFloat(
            //@ts-ignore
            this.state.position[value] * this.getDisplay(group, value).database2display_unit_factor
        ).toFixed(this.getDisplay(group, value).decimal)}${this.getDisplay(group, value).unit}`;
    };

    replayVesselLastTransit = async () => {
        if (!this.state.track?.vessel.name) {
            this.props.showMessageAction({
                messageType: 'WARN',
                message: translate('Cannot find any transits for this vessel.'),
            });
            return;
        }

        this.props.showMessageAction({
            messageType: 'INFO',
            message: translate('Loading replay data, please wait.'),
        });

        const transits = await this.props.mainControls.getVesselLastTransit(this.state.track?.vessel.name);
        if (!transits || transits.length === 0) {
            this.props.showMessageAction({
                messageType: 'WARN',
                message: translate('Cannot find any transits for this vessel.'),
            });
        }
        this.props.mapControls.playback?.clearTooltips();
        if (transits[0]?.id) {
            this.props.mainControls.playbackTransit(transits[0].id, transits[0].end_utc, transits[0]);
        }
    };

    getValue = (items, key) => {
        const item = items.find((item) => item.key == key);
        return item ? item : { value: '-', unite: '' };
    };

    formatValue = (instrumentValues, key, type) => {
        const instrumentValue = this.getValue(instrumentValues, key);
        const display = this.state.enviroDisplay[type][key];

        let value = instrumentValue.value;
        if (value === '-' || !value) {
            return '-';
        }
        if (instrumentValue.unit !== display.unit) {
            value = value * display.database2display_unit_factor;
        }
        if (!value) {
            return 'N/A';
        }
        return `${value.toFixed(display.decimal)} ${display.unit}`;
    };

    reversAngle = (angle) => {
        const difference = angle - 180;

        if (difference < 0) return 360 + difference;

        return difference;
    };

    jumpToTime = () => {
        if (this.props.mode === 'time') {
            this.props.mapControls.time?.jumpToTime(this.state.toolTip?.dataIndex.time);
            this.props.menuControls.time?.setSelectedTime(this.state.toolTip?.dataIndex.time);
        } else {
            this.props.mapControls.playback?.jumpToTime(this.state.toolTip?.dataIndex.time);
        }
    };

    searchVesselLastTransit = async () => {
        if (!this.state.track?.vessel.name) {
            this.props.showMessageAction({
                messageType: 'WARN',
                message: translate('Cannot find any transits for this vessel.'),
            });
            return;
        }
        this.props.openModelFunction(
            'searchVesselTransitModel',
            0,
            'medium',
            {
                vessel: this.state.track?.vessel,
            },
            {
                onCancel: () => {
                    this.props.openModelFunction('searchVesselTransitModel');
                },
                onConfirm: () => {
                    //console.log('saved');
                },
            },
            true
        );
        this.props.mapControls[this.props.mode].hideTooltips();
    };

    addTagsAndComments = (id: number) => {
        this.props.openModelFunction(
            'transitTagsAndCommentsModel',
            0,
            'medium',
            { tab: 'tags', id: id },
            {
                onCancel: () => {
                    this.props.openModelFunction('transitTagsAndCommentsModel');
                },
                onConfirm: () => {
                    console.log('saved');
                },
            },
            true
        );
    };

    render() {
        return (
            <div className="flex flex-col  min-w-56 relative overflow-hidden rounded-md group">
                <div className="w-full h-full absolute z-10" id={`Drag-${this.state?.toolTip?.uuid}`}></div>
                <div className="w-full flex flex-col  ">
                    <div className="flex justify-between gap-x-2 items-start mx-2 mt-2">
                        <div
                            className={twclsx(
                                (!hasPermission(this.props.user, this.props.port.id, ['identifyTransits']) ||
                                    !this.state.switchs.identifyTransits.value) &&
                                    'blurText',
                                'capitalize',
                                'font-bold'
                            )}
                        >
                            {this.state.toolTip?.data.name}

                            <span className="capitalize">
                                ({translate(this.state.track?.vessel.vessel_category.label)})
                            </span>
                        </div>

                        <div className="flex justify-between gap-1 z-20">
                            <div
                                className="cursor-pointer"
                                onClick={() => {
                                    switch (this.props.mode) {
                                        case 'search':
                                            this.props.mapControls.chart?.flagTooltipId(this.props.toolTip.uuid);
                                            break;
                                        case 'time':
                                            this.props.mapControls.time?.flagTooltipId(this.props.toolTip.uuid);
                                            break;
                                        case 'playback':
                                            this.props.mapControls.playback?.flagTooltipId(this.props.toolTip.uuid);
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                            >
                                {this.state.toolTip?.bind ? (
                                    <Icon className="w-4 h-4">
                                        <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"></path>
                                        <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
                                        <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
                                    </Icon>
                                ) : (
                                    <Icon className="w-4 h-4">
                                        <path d="M5 11m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
                                        <path d="M12 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                        <path d="M8 11v-5a4 4 0 0 1 8 0"></path>
                                    </Icon>
                                )}
                            </div>
                            <div
                                onClick={() => {
                                    switch (this.props.mode) {
                                        case 'search':
                                            this.props.mapControls.chart?.hideTooltipById(this.props.toolTip.uuid);
                                            break;
                                        case 'time':
                                            this.props.mapControls.time?.hideTooltipById(this.props.toolTip.uuid);
                                            break;
                                        case 'playback':
                                            this.props.mapControls.playback?.hideTooltipById(this.props.toolTip.uuid);
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                                className="flex justify-center items-end justify-items-end cursor-pointer"
                            >
                                <Icon className="w-4 h-4">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M18 6l-12 12"></path>
                                    <path d="M6 6l12 12"></path>
                                </Icon>
                            </div>
                        </div>
                    </div>

                    {this.state.loading ? (
                        <LoaderSpinner className="my-10 mx-20" variant="button"></LoaderSpinner>
                    ) : (
                        <>
                            <div className="flex-1 truncate mx-2">
                                <div className="flex justify-between items-start">
                                    <div className="  items-center   ">
                                        <h3 className="text-activeGray text-sm leading-5 font-medium truncate">
                                            {this.state.track?.vessel.loa_m}
                                            {this.getDisplay('vessel', 'loa_m').unit} x{' '}
                                            {this.state.track?.vessel.beam_m}
                                            {this.getDisplay('vessel', 'beam_m').unit} (
                                            {this.displayValue('draft_m', 'vessel')}
                                            {this.getDisplay('vessel', 'draft_m').unit})
                                        </h3>
                                        <p
                                            className={twMerge(
                                                this.props.toolTip.dataIndex.time &&
                                                    this.props?.currentTime &&
                                                    this.props?.currentTime?.getDiffInSeconds(
                                                        this.props.toolTip.dataIndex.time
                                                    ) <
                                                        (this.state.toolTip?.dataIndex?.navigational_status_id === 5 ||
                                                        this.state.toolTip?.dataIndex?.navigational_status_id === 1
                                                            ? this.state.analysisVariables?.aisDataDropoutMoored_seconds
                                                            : this.state.analysisVariables
                                                                  ?.aisDataDropoutUnderway_seconds)
                                                    ? ' text-red-500'
                                                    : ' text-gray-500',
                                                'mb-1',
                                                'text-sm',
                                                'font-bold',
                                                'leading-4',
                                                'truncate'
                                            )}
                                        >
                                            <span
                                                className={twclsx(
                                                    (!hasPermission(this.props.user, this.props.port.id, [
                                                        'identifyTransits',
                                                    ]) ||
                                                        !this.state.switchs.identifyTransits.value) &&
                                                        'blurText'
                                                )}
                                            >
                                                {this.props.toolTip.dataIndex.time.formatDateTimeToString(
                                                    'dd LLL yyyy'
                                                )}
                                            </span>
                                            <span className="ml-1">
                                                {this.props.toolTip.dataIndex.time.formatDateTimeToString('HH:mm:ss Z')}
                                            </span>
                                        </p>
                                    </div>
                                </div>
                                <div className="h-px w-full bg-gray-300 my-1"></div>
                            </div>
                            {this.state.switchs[
                                this.props.mode === 'playback'
                                    ? 'playbackManoeuvreInformationOnChart'
                                    : 'timeManoeuvreInformationOnChart'
                            ]?.value && (
                                <div className="py-1  text-sm border-b border-gray-400 ">
                                    <div className="w-full border-collapse items-center">
                                        <div className="flex justify-between ">
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-5/12">
                                                <div className="w-2/3">
                                                    {this.getDisplay('transit', 'heading_deg').name} :
                                                </div>

                                                <div className="text-black font-bold  pl-2 text-right w-1/3">
                                                    {this.displayValue('heading_deg')}
                                                </div>
                                            </div>

                                            <div className="text-gray-600 font-bold flex justify-start text-right w-7/12">
                                                <div className="w-1/2">
                                                    {this.getDisplay('transit', 'sog_mps').name} :
                                                </div>
                                                <div className="text-black font-bold  pl-2 text-left w-1/2">
                                                    {this.displayValue('sog_mps')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-between ">
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-5/12">
                                                <div className="w-2/3">
                                                    {this.getDisplay('transit', 'cog_deg').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-right w-1/3">
                                                    {this.displayValue('cog_deg')}
                                                </div>
                                            </div>
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-7/12">
                                                <div className="w-1/2">
                                                    {this.getDisplay('transit', 'rot_deg_min').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-left w-1/2">
                                                    {this.displayValue('rot_deg_min')}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="flex justify-between ">
                                            <div className="text-gray-600 font-bold flex justify-start text-right w-5/12">
                                                <div className="w-2/3">
                                                    {this.getDisplay('transit', 'drift_angle_deg').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-right w-1/3">
                                                    {this.displayValue('drift_angle_deg')}
                                                </div>
                                            </div>

                                            <div className="text-gray-600 font-bold flex justify-start text-right w-7/12">
                                                <div className="w-1/2">
                                                    {this.getDisplay('transit', 'crot_deg_min').name} :
                                                </div>
                                                <div className="text-black font-bold pl-2 text-left w-1/2">
                                                    {this.displayValue('crot_deg_min')}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {this.state.switchs[
                                this.props.mode === 'playback'
                                    ? 'playbackEnviromentalDataOnChart'
                                    : 'timeEnviromentalDataOnChart'
                            ]?.value && (
                                <div className="py-1 border-b text-sm    border-gray-400 mx-2 ">
                                    <div className=" flex grow-0 flex-content text-center border-b border-gray-400 pb-1">
                                        {this.state.metOceanData.filter((x) => {
                                            return x.key == 'wind' && x.instruments.length >= 1;
                                        }).length && this.state.switchs.windData.value ? (
                                            <div
                                                className={twclsx(
                                                    'border-r',
                                                    'border-gray-400',
                                                    'px-2',
                                                    'grow',
                                                    'cursor-pointer',
                                                    'z-20',
                                                    this.state.activeTab === 'wind' ? 'text-primary-link' : 'text-black'
                                                )}
                                                onClick={() => {
                                                    this.activeTab('wind');
                                                }}
                                            >
                                                {translate('Wind')}
                                            </div>
                                        ) : null}
                                        {this.state.metOceanData.filter((x) => {
                                            return x.key == 'watercurrent' && x.instruments.length >= 1;
                                        }).length && this.state.switchs.watercurrentData.value ? (
                                            <div
                                                className={twclsx(
                                                    'border-r',
                                                    'border-gray-400',
                                                    'px-2',
                                                    'grow',
                                                    'cursor-pointer',
                                                    'z-20',
                                                    this.state.activeTab === 'watercurrent'
                                                        ? 'text-primary-link'
                                                        : 'text-black'
                                                )}
                                                onClick={() => {
                                                    this.activeTab('watercurrent');
                                                }}
                                            >
                                                {translate('Water current')}
                                            </div>
                                        ) : null}
                                        {this.state.metOceanData.filter((x) => {
                                            return x.key == 'tide' && x.instruments.length >= 1;
                                        }).length && this.state.switchs.tideData.value ? (
                                            <div
                                                className={twclsx(
                                                    'border-r',
                                                    'border-gray-400',
                                                    'px-2',
                                                    'grow',
                                                    'cursor-pointer',
                                                    'z-20',
                                                    this.state.activeTab === 'tide' ? 'text-primary-link' : 'text-black'
                                                )}
                                                onClick={() => {
                                                    this.activeTab('tide');
                                                }}
                                            >
                                                {translate('tide')}
                                            </div>
                                        ) : null}
                                        {this.state.metOceanData.filter((x) => {
                                            return x.key == 'wave' && x.instruments.length >= 1;
                                        }).length && this.state.switchs.waveData.value ? (
                                            <div
                                                className={twclsx(
                                                    'px-2',
                                                    'grow',
                                                    'cursor-pointer',
                                                    'z-20',
                                                    this.state.activeTab === 'wave' ? 'text-primary-link' : 'text-black'
                                                )}
                                                onClick={() => {
                                                    this.activeTab('wave');
                                                }}
                                            >
                                                {translate('Wave')}
                                            </div>
                                        ) : null}
                                    </div>
                                    {/* wind */}
                                    {this.state.activeTab === 'wind' && (
                                        <div className="flex flex-col    px-1">
                                            {this.state.metOceanData
                                                .filter((x) => x.key == 'wind')
                                                .map((instrumentType, instrumentIndex) => {
                                                    return (
                                                        <div key={instrumentIndex}>
                                                            <div>
                                                                {instrumentType.instruments.map(
                                                                    (instrument, instrumentIndex) => {
                                                                        return (
                                                                            <div
                                                                                key={instrumentIndex}
                                                                                className=" text-sm gap-1 items-center"
                                                                            >
                                                                                <table className="w-full">
                                                                                    <tr>
                                                                                        <td
                                                                                            className="w-40"
                                                                                            rowSpan={2}
                                                                                        >
                                                                                            <p className="w-32 truncate">
                                                                                                {instrument.description}
                                                                                            </p>
                                                                                        </td>
                                                                                        <td className="flex gap-1 items-center justify-end pr-2">
                                                                                            <div className="z-20 leading-4 relative flex items-center justify-end">
                                                                                                {this.getValue(
                                                                                                    instrument.values,
                                                                                                    'direction_from_deg'
                                                                                                ).value != '-' && (
                                                                                                    <DirectionArraw
                                                                                                        name={translate(
                                                                                                            'direction_from_deg'
                                                                                                        )}
                                                                                                        degree={this.reversAngle(
                                                                                                            this.getValue(
                                                                                                                instrument.values,
                                                                                                                'direction_from_deg'
                                                                                                            ).value
                                                                                                        )}
                                                                                                    ></DirectionArraw>
                                                                                                )}
                                                                                            </div>

                                                                                            <div>
                                                                                                {this.formatValue(
                                                                                                    instrument.values,
                                                                                                    'speed_kn',
                                                                                                    instrumentType.key
                                                                                                )}
                                                                                            </div>
                                                                                            <div>
                                                                                                {translate('gust')}{' '}
                                                                                                {this.formatValue(
                                                                                                    instrument.values,
                                                                                                    'gust_kn',
                                                                                                    instrumentType.key
                                                                                                )}
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    )}

                                    {/* watercurrent */}
                                    {this.state.activeTab === 'watercurrent' && (
                                        <div className="flex flex-col    px-1">
                                            {this.state.metOceanData
                                                .filter((x) => x.key == 'watercurrent')
                                                .map((instrumentType, instrumentIndex) => {
                                                    return (
                                                        <div key={instrumentIndex}>
                                                            <div>
                                                                {instrumentType.instruments.map(
                                                                    (instrument, instrumentIndex) => {
                                                                        return (
                                                                            <div
                                                                                key={instrumentIndex}
                                                                                className=" text-sm gap-1 items-center"
                                                                            >
                                                                                <table className="w-full">
                                                                                    <tr>
                                                                                        <td
                                                                                            className="w-40"
                                                                                            rowSpan={2}
                                                                                        >
                                                                                            <p className="w-32 truncate">
                                                                                                {instrument.description}
                                                                                            </p>
                                                                                        </td>
                                                                                        <td className="flex items-center justify-end pr-2">
                                                                                            <div className=" z-20 leading-4 relative flex items-center">
                                                                                                {this.getValue(
                                                                                                    instrument.values,
                                                                                                    'direction_from_deg'
                                                                                                ).value !== '-' && (
                                                                                                    <DirectionArraw
                                                                                                        name={translate(
                                                                                                            'direction_from_deg'
                                                                                                        )}
                                                                                                        degree={this.reversAngle(
                                                                                                            this.getValue(
                                                                                                                instrument.values,
                                                                                                                'direction_from_deg'
                                                                                                            ).value
                                                                                                        )}
                                                                                                    ></DirectionArraw>
                                                                                                )}

                                                                                                <div>
                                                                                                    {this.formatValue(
                                                                                                        instrument.values,
                                                                                                        'speed_kn',
                                                                                                        instrumentType.key
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    )}
                                    {/* tide */}
                                    {this.state.activeTab === 'tide' && (
                                        <div className="flex flex-col    px-1">
                                            {this.state.metOceanData
                                                .filter((x) => x.key == 'tide')
                                                .map((instrumentType, instrumentIndex) => {
                                                    return (
                                                        <div key={instrumentIndex}>
                                                            <div>
                                                                {instrumentType.instruments.map(
                                                                    (instrument, instrumentIndex) => {
                                                                        return (
                                                                            <div
                                                                                key={instrumentIndex}
                                                                                className=" text-sm gap-1 items-center"
                                                                            >
                                                                                <table className="w-full">
                                                                                    <tr>
                                                                                        <td
                                                                                            className="w-40"
                                                                                            rowSpan={2}
                                                                                        >
                                                                                            <p className="w-32 truncate">
                                                                                                {instrument.description}
                                                                                            </p>
                                                                                        </td>
                                                                                        <td className=" relative flex items-center "></td>
                                                                                        <td
                                                                                            rowSpan={2}
                                                                                            className="flex items-center justify-end pr-2"
                                                                                        >
                                                                                            <div className="flex items-center relative">
                                                                                                <Icon className="w-3 h-3 mr-1">
                                                                                                    <path
                                                                                                        stroke="none"
                                                                                                        d="M0 0h24v24H0z"
                                                                                                        fill="none"
                                                                                                    ></path>
                                                                                                    <polyline points="3 8 6 5 9 8"></polyline>
                                                                                                    <polyline points="3 16 6 19 9 16"></polyline>
                                                                                                    <line
                                                                                                        x1="6"
                                                                                                        y1="5"
                                                                                                        x2="6"
                                                                                                        y2="19"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="13"
                                                                                                        y1="6"
                                                                                                        x2="20"
                                                                                                        y2="6"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="13"
                                                                                                        y1="12"
                                                                                                        x2="20"
                                                                                                        y2="12"
                                                                                                    ></line>
                                                                                                    <line
                                                                                                        x1="13"
                                                                                                        y1="18"
                                                                                                        x2="20"
                                                                                                        y2="18"
                                                                                                    ></line>
                                                                                                </Icon>
                                                                                                <div>
                                                                                                    {this.formatValue(
                                                                                                        instrument.values,
                                                                                                        'height_m',
                                                                                                        instrumentType.key
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                        <td> </td>
                                                                                    </tr>

                                                                                    <tr>
                                                                                        <td className="flex items-center "></td>

                                                                                        <td> </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    )}
                                    {/* wave */}
                                    {this.state.activeTab === 'wave' && (
                                        <div className="flex flex-col    px-1">
                                            {this.state.metOceanData
                                                .filter((x) => x.key == 'wave')
                                                .map((instrumentType, instrumentIndex) => {
                                                    return (
                                                        <div key={instrumentIndex}>
                                                            <div>
                                                                {instrumentType.instruments.map(
                                                                    (instrument, instrumentIndex) => {
                                                                        return (
                                                                            <div
                                                                                key={instrumentIndex}
                                                                                className=" text-sm gap-1 items-center"
                                                                            >
                                                                                <table className="w-full">
                                                                                    <tr>
                                                                                        <td
                                                                                            className="w-40"
                                                                                            rowSpan={4}
                                                                                        >
                                                                                            <div className="flex w-32">
                                                                                                <div
                                                                                                    className="truncate"
                                                                                                    title={
                                                                                                        instrument.description
                                                                                                    }
                                                                                                >
                                                                                                    {
                                                                                                        instrument.description
                                                                                                    }
                                                                                                </div>
                                                                                                {this.getValue(
                                                                                                    instrument.values,
                                                                                                    'mean_direction_from_deg'
                                                                                                ).value != '-' && (
                                                                                                    <div className="z-20  leading-4 relative flex items-center">
                                                                                                        {this.getValue(
                                                                                                            instrument.values,
                                                                                                            'mean_direction_from_deg'
                                                                                                        ).value !==
                                                                                                            null && (
                                                                                                            <DirectionArraw
                                                                                                                name={translate(
                                                                                                                    'mean_direction_from_deg'
                                                                                                                )}
                                                                                                                degree={
                                                                                                                    this.getValue(
                                                                                                                        instrument.values,
                                                                                                                        'mean_direction_from_deg'
                                                                                                                    )
                                                                                                                        .value
                                                                                                                }
                                                                                                            ></DirectionArraw>
                                                                                                        )}
                                                                                                    </div>
                                                                                                )}
                                                                                            </div>
                                                                                        </td>
                                                                                        <td></td>
                                                                                        <td></td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td>
                                                                                            <div className="grid grid-rows-3">
                                                                                                <div className="row-span-1 grid grid-cols-2 items-end ">
                                                                                                    <td className="text-sm col-span-1">
                                                                                                        sea
                                                                                                    </td>
                                                                                                    <td className="flex  gap-4 justify-start items-center col-span-1">
                                                                                                        <div>
                                                                                                            {this.formatValue(
                                                                                                                instrument.values,
                                                                                                                'significant_wave_height_sea_m',
                                                                                                                instrumentType.key
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            {this.formatValue(
                                                                                                                instrument.values,
                                                                                                                'peak_wave_period_sea_s',
                                                                                                                instrumentType.key
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </div>
                                                                                                <div className="row-span-1 grid grid-cols-2 items-end ">
                                                                                                    <td className="text-sm  col-span-1">
                                                                                                        swell
                                                                                                    </td>
                                                                                                    <td className="flex  gap-4 justify-start items-center col-span-1">
                                                                                                        <div>
                                                                                                            {this.formatValue(
                                                                                                                instrument.values,
                                                                                                                'significant_wave_height_swell_m',
                                                                                                                instrumentType.key
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            {this.formatValue(
                                                                                                                instrument.values,
                                                                                                                'peak_wave_period_swell_s',
                                                                                                                instrumentType.key
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </div>
                                                                                                <div className="row-span-1 grid grid-cols-2 items-end ">
                                                                                                    <td className="text-sm col-span-1">
                                                                                                        total
                                                                                                    </td>
                                                                                                    <td className="flex  gap-4 justify-start items-center col-span-1">
                                                                                                        <div>
                                                                                                            {this.formatValue(
                                                                                                                instrument.values,
                                                                                                                'significant_wave_height_total_m',
                                                                                                                instrumentType.key
                                                                                                            )}
                                                                                                        </div>
                                                                                                        <div>
                                                                                                            {this.formatValue(
                                                                                                                instrument.values,
                                                                                                                'peak_wave_period_total_s',
                                                                                                                instrumentType.key
                                                                                                            )}
                                                                                                        </div>
                                                                                                    </td>
                                                                                                </div>
                                                                                            </div>
                                                                                        </td>
                                                                                    </tr>
                                                                                </table>
                                                                            </div>
                                                                        );
                                                                    }
                                                                )}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="z-20 text-left bg-primary-system   px-2 h-0 truncate group-hover:h-8 transition-all ease-in-out duration-300">
                                <div className="flex items-start ">
                                    {this.state.track?.options.display ? (
                                        <div
                                            onClick={() => {
                                                this.props.menuControls[this.props.mode]?.trackDisplay(
                                                    //@ts-ignore
                                                    this.state.track?.uuid,
                                                    false
                                                );
                                                this.props.mapControls[this.props.mode].hideTooltips();
                                            }}
                                            className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                            data-tooltip-id="hideVessel"
                                        >
                                            <Tooltip
                                                id="hideVessel"
                                                html={`${
                                                    this.state.track?.options.display
                                                        ? translate('Hide vessel')
                                                        : translate('Show vessel')
                                                }`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-primary-activeTextColor">
                                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                                                {this.state.track?.options.display ? (
                                                    <path d="M3 3l18 18"></path>
                                                ) : (
                                                    <></>
                                                )}
                                            </Icon>
                                        </div>
                                    ) : (
                                        <div
                                            onClick={() => {
                                                this.props.menuControls[this.props.mode]?.trackDisplay(
                                                    //@ts-ignore
                                                    this.state.track?.uuid,
                                                    true
                                                );
                                                this.props.mapControls[this.props.mode].hideTooltips();
                                            }}
                                            className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                            data-tooltip-id="showVessel"
                                        >
                                            <Tooltip
                                                id="showVessel"
                                                html={`${translate('Show vessel')}`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-primary-activeTextColor">
                                                <path d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                                                <path d="M21 12c-2.4 4 -5.4 6 -9 6c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.6 0 6.6 2 9 6"></path>
                                                {this.state.track?.options.display ? (
                                                    <path d="M3 3l18 18"></path>
                                                ) : (
                                                    <></>
                                                )}
                                            </Icon>
                                        </div>
                                    )}

                                    <div
                                        onClick={() => {
                                            this.props.menuControls[this.props.mode]?.trackDrawTrack(
                                                //@ts-ignore
                                                this.state.track?.uuid,
                                                !this.state.track?.options.drawTrack
                                            );
                                            this.props.mapControls[this.props.mode].hideTooltips();
                                        }}
                                        className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                        data-tooltip-id="vesselTrack"
                                    >
                                        <Tooltip
                                            id="vesselTrack"
                                            html={`${
                                                this.state.track?.options.drawTrack
                                                    ? translate('Hide vessel track')
                                                    : translate('Show vessel track')
                                            }`}
                                            place="top"
                                            positionStrategy="fixed"
                                            className="z-60"
                                        />
                                        <Icon className="w-4 h-4 text-primary-activeTextColor">
                                            <path d="M4 16l6 -7l5 5l5 -6"></path>
                                            <path d="M15 14m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                            <path d="M10 9m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                            <path d="M4 16m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                            <path d="M20 8m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                            {this.state.track?.options.drawTrack ? <path d="M3 3l18 18"></path> : <></>}
                                        </Icon>
                                    </div>
                                    {this.state.track?.options.group === 'transitVessels' && (
                                        <div
                                            onClick={() => {
                                                //@ts-ignore
                                                this.addTagsAndComments(this.state.track?.options.transitId);
                                            }}
                                            className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                            data-tooltip-id="tooltipTagsAndComments"
                                        >
                                            <Tooltip
                                                id="tooltipTagsAndComments"
                                                html={`${translate('Tags and comments')}`}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-primary-activeTextColor">
                                                <path d="M7.5 7.5m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0"></path>
                                                <path d="M3 6v5.172a2 2 0 0 0 .586 1.414l7.71 7.71a2.41 2.41 0 0 0 3.408 0l5.592 -5.592a2.41 2.41 0 0 0 0 -3.408l-7.71 -7.71a2 2 0 0 0 -1.414 -.586h-5.172a3 3 0 0 0 -3 3z"></path>
                                            </Icon>
                                        </div>
                                    )}
                                    {(this.state.track?.options.group === 'otherTransits' ||
                                        this.state.track?.options.group === 'transitVessels') && (
                                        <>
                                            <div
                                                className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                                onClick={this.replayVesselLastTransit}
                                                data-tooltip-id="replayTransit"
                                            >
                                                <Tooltip
                                                    id="replayTransit"
                                                    html={translate('Replay the most recent transit')}
                                                    place="top"
                                                    positionStrategy="fixed"
                                                    className="z-60"
                                                />
                                                <Icon className="w-4 h-4 text-primary-activeTextColor">
                                                    <path d="M4 12v-3a3 3 0 0 1 3 -3h13m-3 -3l3 3l-3 3"></path>
                                                    <path d="M20 12v3a3 3 0 0 1 -3 3h-13m3 3l-3 -3l3 -3"></path>
                                                </Icon>
                                            </div>

                                            <div
                                                className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                                onClick={this.searchVesselLastTransit}
                                                data-tooltip-id="searchTransit"
                                            >
                                                <Tooltip
                                                    id="searchTransit"
                                                    html={translate('search for recent transits')}
                                                    place="top"
                                                    positionStrategy="fixed"
                                                    className="z-60"
                                                />
                                                <Icon className="w-4 h-4 text-primary-activeTextColor">
                                                    <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0" />
                                                    <path d="M21 21l-6 -6" />
                                                </Icon>
                                            </div>
                                        </>
                                    )}
                                    {this.props.toolTip.type === 'vesselTrack' && (
                                        <div
                                            className=" cursor-pointer text-left ml-1 -mr-px  inline-flex items-left justify-start items-center py-2  leading-4 text-primary font-medium border border-transparent rounded-bl-lg hover:text-blue-800 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 transition ease-in-out duration-300 z-40"
                                            onClick={this.jumpToTime}
                                            data-tooltip-id="JumpToHere"
                                        >
                                            <Tooltip
                                                id="JumpToHere"
                                                html={translate('Jump to here')}
                                                place="top"
                                                positionStrategy="fixed"
                                                className="z-60"
                                            />
                                            <Icon className="w-4 h-4 text-primary-activeTextColor">
                                                <path d="M20.943 13.016a9 9 0 1 0 -8.915 7.984" />
                                                <path d="M16 22l5 -5" />
                                                <path d="M21 21.5v-4.5h-4.5" />
                                                <path d="M12 7v5l2 2" />
                                            </Icon>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        );
    }
}

const vesselToolTipStateToProps = (state: RootState) => ({
    outlineInterval: state.map.outlineInterval,
    switchs: state.layout.switchs,
    port: state.port.port,
    dateTimeFormat: state.port.dateTimeFormat,
    mainControls: state.layout.mainControls,
    menuControls: state.layout.menuControls,
    mapControls: state.map.mapControls,
    openModelFunction: state.layout.openModelFunction,
    user: state.user.user,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const vesselToolTipDispatchToProps = (dispatch: any) => ({
    setOutlineIntervalAction: bindActionCreators(setOutlineIntervalAction, dispatch),
    showMessageAction: bindActionCreators(showMessageAction, dispatch),
});

export default connect(vesselToolTipStateToProps, vesselToolTipDispatchToProps)(VesselToolTip);
